import bindAllOfThis, { bindAllOfThisTheHardWay } from 'src/utils/BindThisHelper';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import TranslateApi from 'src/utils/TranslateHelper';
import { EndGameScene } from './EndGameScene';
import { Player } from '../objects/Player';
import { numKeys } from 'src/constants/KeyboardNumKeys';
class Command {
    name: "throw" | "pass" | "shoot";
    coachCommand: string;
    coachEncouragement: string;
    keyboardBinding: number;
}

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;
    buttons: Phaser.GameObjects.Image[];
    ball: Phaser.GameObjects.Sprite;
    thrower: Player;
    passer: Player;
    shooter: Player;
    command: Command;
    commandText: Phaser.GameObjects.Text;
    bubbleArea: Phaser.GameObjects.Zone;
    ballHandler: Player;

    commands: Command[] = [
        {
            name: "throw",
            coachCommand: TranslateApi.translate("Starball.Phaser.throw"),
            coachEncouragement: TranslateApi.translate("Starball.Phaser.throwEncouragement"),
            keyboardBinding: 2
        },
        {
            name: "pass",
            coachCommand: TranslateApi.translate("Starball.Phaser.pass"),
            coachEncouragement: TranslateApi.translate("Starball.Phaser.passEncouragement"),
            keyboardBinding: 3
        },
        {
            name: "shoot",
            coachCommand: TranslateApi.translate("Starball.Phaser.shoot"),
            coachEncouragement: TranslateApi.translate("Starball.Phaser.shootEncouragement"),
            keyboardBinding: 1
        },
    ];

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/starball.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/ke_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameStarball.png"), require("src/assets/qci/atlas/gameStarball.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.command = this.commands[0];
        this.buttons = [];
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);

        this.createScene();
        this.createButtons();
        this.createPlayers();
        this.ballHandler = this.thrower;
        this.bindNumKeys();
    }

    createButtons() {
        var style = { fontFamily: "Russo One, Arial", fontSize: 20, color: "#000000" };
        let i: number = 1;
        this.map.getObjectLayer("Buttons").objects.forEach((ob: TiledGameObject) => {
            var button = this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", 'button');
            button.setName(ob.name);
            button.setInteractive({ useHandCursor: true });

            if (button.name !== "throw") {
                button.setTint(0x767a82);
                button.input.enabled = false;
            }

            button.on('pointerdown', () => {
                if (this.tweens.isTweening(this.ball)) {
                    return;
                }

                switch (button.name) {
                    case "throw":
                        this.throw();
                        return;
                    case "pass":
                        this.pass();
                        return;
                    case "shoot":
                        this.shoot();
                        return;
                }
            });



            this.buttons.push(button);
            let keyboardBinding: number = this.commands.find((c: Command) => c.name === ob.name).keyboardBinding;
            var text = this.add.text(ob.x, ob.y, keyboardBinding + ': ' + TranslateApi.translate("Starball.Phaser." + ob.name), style);
            Phaser.Display.Align.In.Center(text, button);
            i++;
        });
    } 

    createScene() {
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "coach") {
                var coach = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "coach");
            }
            else if (ob.name === "text") {
                var style = { fontSize: 50, fontFamily: "Russo One, Arial", color: "#000000", align: "center" };
                this.commandText = this.add.text(ob.x, ob.y, this.command.coachCommand, style);
                this.commandText.setWordWrapWidth(300, true);
            }
            else if (ob.name === "bubble") {
                var bubble = this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "bubble");
            }
            else if (ob.name === "bubbleArea") {
                this.bubbleArea = this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
            }
            else if (ob.name === "ball") {
                this.ball = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "ball1");
                this.anims.create({
                    key: "rotate",
                    frames: this.anims.generateFrameNames("assets", { prefix: "ball", start: 1, end: 4 }),
                    frameRate: 4,
                });
            }
            else if (ob.name === "goal") {
                var goal = this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "goal");
            }
        });
        Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
    }

    createPlayers() {
        this.map.getObjectLayer("Players").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "passer") {
                this.passer = new Player(this, ob);
            }
            else if (ob.name === "shooter") {
                this.shooter = new Player(this, ob);
            }
            else if (ob.type === "Visitor") {
                var id = ob.properties["id"] as number;
                var visitor = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "visitor" + id + "1");
                this.anims.create({
                    key: "visitor" + id,
                    frames: this.anims.generateFrameNames("assets", { prefix: "visitor" + id, start: 1, end: 2 }),
                    frameRate: ob.properties["rate"],
                    repeat: -1,
                });
                visitor.anims.play("visitor" + id);
            }
            else if (ob.name === "thrower") {
                this.thrower = new Player(this, ob);
                this.thrower.hasBall = true;
            }
        });
    }

    throw(): void {
        if (!this.thrower.hasBall) {
            return;
        }
        this.thrower.play('throw');
        this.ball.play("rotate");
        this.input.enabled = false;

        this.buttons.forEach((b) => {
            if (b.name === "throw") {
                b.input.enabled = false;
            }
            this.buttons.forEach((b) => {
                b.setTint(0x767a82);
            });
        });

        // Arc tween like throwing in from sideline to player1
        var timeline = this.tweens.timeline({
            targets: this.ball,
            delay: 120,
            tweens: [
                {
                    x: this.passer.x,
                    ease: 'Sine.easeInOut',
                    duration: 1200,
                },
                {
                    y: 300,
                    ease: 'Sine.easeOut',
                    duration: 600,
                    offset: 0
                },
                {
                    y: this.passer.y,
                    ease: "Bounce.easeOut",//'Sine.easeIn',
                    duration: 600
                }
            ],
            onComplete: () => {
                this.ballHandler = this.passer;
                this.commandText.setText(this.command.coachEncouragement);
                Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
                setTimeout(() => {
                    this.setCommand(1);
                    this.buttons.forEach((b) => {
                        if (b.name !== "throw") {
                            b.clearTint();
                            b.input.enabled = true;
                        }
                    });
                }, 1000);

            }
        });

    }

    pass() {
        this.input.enabled = false;
        this.buttons.forEach((b) => {
            b.setTint(0x767a82);
        });

        var newBallHandler;
        if (this.ballHandler.name === "shooter") {
            newBallHandler = this.passer;
        }
        else if (this.ballHandler.name === "passer") {
            newBallHandler = this.shooter;
        }

        this.ballHandler.anims.play(this.ballHandler.name + 'kick');
        this.ball.play("rotate");

        // Linear tween like kicking ball diagonally to player 2
        this.tweens.add({
            targets: this.ball,
            delay: 120,
            x: newBallHandler.x,
            y: newBallHandler.y,
            ease: "Linear",
            duration: 1000,
            onComplete: () => {
                this.ballHandler = newBallHandler;
                this.commandText.setText(this.commands.find((c: Command) => c.name === "pass").coachEncouragement);
                Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);

                if (this.ballHandler.name === "shooter") {
                    // Passed correctly to the shooter, now move on to next command
                    setTimeout(() => {
                        this.setCommand(2);
                    }, 1000);
                }
                else {
                    // Passed incorrectly to the passer, show "Shoot" command again
                    setTimeout(() => {
                        this.setCommand(1);
                    }, 1000);
                }
            }
        });
    }

    shoot() {
        this.buttons.forEach((b) => {
            b.setTint(0x767a82);
        });

        if (this.ballHandler.name === "shooter") {
            this.shootAndScore();
        }
        else {
            this.shootAndBlock();
        }
    }

    shootAndBlock() {
        this.ballHandler.anims.play(this.ballHandler.name + 'kick');
        this.ball.play("rotate");
        this.input.enabled = false;

        // Linear tween like kicking ball into goal
        this.tweens.timeline({
            targets: this.ball,
            tweens: [
                {
                    x: this.gameWidth / 2 + 35,
                    ease: 'Sine.easeInOut',
                    duration: 1000,
                    y: 430,
                },
                {
                    x: this.ballHandler.x,
                    ease: 'Sine.easeInOut',
                    duration: 1000,
                    y: this.ballHandler.y,
                }
            ],
            onComplete: () => {
                this.commandText.setText(TranslateApi.translate("Starball.Phaser.blocked"));
                Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
                setTimeout(() => {
                    this.setCommand(1);
                }, 1000);
            }
        });
    }

    shootAndScore() {
        this.ballHandler.anims.play(this.ballHandler.name + 'kick');
        this.ball.play("rotate");
        this.input.enabled = false;

        // Linear tween like kicking ball into goal
        this.tweens.add({
            targets: this.ball,
            x: this.gameWidth / 2 - 50,
            ease: 'Sine.easeInOut',
            duration: 1000,
            y: 480,
            onComplete: () => {
                this.endGame();
            }
        });
    }

    setCommand(index) {
        this.command = this.commands[index];
        this.commandText.setText(this.command.coachCommand);
        Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
        this.input.enabled = true;
        this.buttons.forEach((b) => {
            if (b.name !== "throw") {
                b.clearTint();
            }
        });
    }

    endGame() {
        this.commandText.setText(this.command.coachEncouragement);
        Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
        setTimeout(() => {
            this.input.enabled = false;
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.input.keyboard.on('keydown_' + key, event);
        });
    }

    bindNumKeys(): void {
        this.commands.forEach((command: Command) => {
            let numKey = numKeys[command.keyboardBinding - 1];
            this.onKeydown(() => {
                if (this.tweens.isTweening(this.ball)) {
                    return;
                }

                switch (command.name) {
                    case "throw":
                        this.throw();
                        return;
                    case "pass":
                        this.pass();
                        return;
                    case "shoot":
                        this.shoot();
                        return;
                }
            }, numKey.keyCode, numKey.altKeyCode);
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/StarballGame/scenes/MainScene.ts